module.exports = __webpack_public_path__ + "img/lighting.7fddbfce.png";